<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalGenerationCapacity"
  >
    <div class="modal-dialog modal-width modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title" style="font-weight: 600; text-transform: uppercase;">
            PROJECTS {{ title }}<br />
            <!-- <p class="card_title_2">Last Updated: {{ lastUpdate }}</p> -->
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="stage" style="color: #8e8e8e">Stage</label>
            <div tabindex="0" @focusout="onFocusOut" @focus="onFocusIn">
              <div class="data-stage-parent">
                <input
                  @focus="isDropdown = true"
                  class="data-stage"
                  style="
                    position: relative;
                    width: 100%;
                    background-color: #e6e6e6;
                    border-radius: 10px;
                    border: none;
                    padding: 4px;
                  "
                  type="text"
                  v-model="selectedStage"
                  readonly
                />
                <span class="fa fa-chevron-down errspan"></span>
              </div>

              <div
                v-show="isDropdown"
                style="
                  position: absolute;
                  width: calc(100% - 32px);
                  height: 300px;
                  overflow-y: scroll;
                  top: 82px;
                  background-color: white;
                  border: 1px solid #cccccc;
                  border-radius: 4px;
                  padding: 4px;
                  -ms-overflow-style: none; /* IE and Edge */
                  scrollbar-width: none; /* Firefox */
                "
              >
                <div v-for="i in stages">
                  <div
                    @mousedown="preventBlur"
                    style="display: flex; justify-content: space-between"
                  >
                    <div>
                      <label :for="'cb_' + i">{{ i.label }}</label>
                    </div>
                    <div>
                      <input
                        :id="'cb_' + i.label"
                        type="checkbox"
                        :value="i.label"
                        v-model="selectedStage"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="project-item"
            style="
              font-size: 12px;
              padding-top: 4px;
              padding-bottom: 4px;
              border-top: 1px solid #dddddd;
              border-bottom: 1px solid #dddddd;
            "
          >
            <span style="color: #8e8e8e">PROJECT</span>
            <span>STAGE</span>
          </div>
          <div class="project-list">
            <div v-for="project in filteredProjects" :key="project.name">
              <div class="project-item">
                <span style="padding-right: 20px">{{ project.projects }}</span>
                <span style="color: #00a3e9">{{ project.stage }}</span>
              </div>
              <div style="border: 1px solid #eeeeee; margin-bottom: 10px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import GenerationService from "@/services/generation/generation";

const getRef = GenerationService.build();

export default {
  props: ["lastUpdate", "showModal", "projects", "filter", "title"],
  components: {
    IconSvg,
  },

  data() {
    return {
      modal: null,
      selectedStage: [],
      stages: [],
      isTextInputFocus: false,
      isDropdown: false,
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalGenerationCapacity);
  },

  computed: {
    filteredProjects() {
      const stg = this.selectedStage;
      const prj = this.projects;
      return prj.filter((person) => stg.includes(person.stage));
    },
  },

  methods: {
    async getStage() {
      const res = await getRef.getRefStage();
      const data = res.data.data;
      this.stages = data;
      this.selectedStage = data.map((obj) => obj.label);
    },
    closeModal() {
      this.$emit("closeModal", false);
    },

    hideDropdown() {
      setTimeout(() => {
        this.isDropdown = false;
      }, 100);
    },
    onFocusOut(event) {
      this.isDropdown = !this.isDropdown;
      //}
    },
    onFocusIn(event) {
      this.isDropdown = true;
    },
    preventBlur(event) {
      event.preventDefault();
    },
  },

  watch: {
    selectedStage() {
      // const stg = this.selectedStage;
      // const prj = this.projects;
      // const result = prj.find((obj) => stg.includes(obj.stage));
      // this.projects = result;
    },
    showModal() {
      if (this.showModal) {
        this.getStage();
        // this.selectedStage = [
        //   "Procurement Planning",
        //   "Procurement",
        //   "Konstruksi",
        //   "OBC",
        //   "COD",
        //   "Tim Verifikasi Validasi (TVV)",
        //   "Centralized Planning",
        //   null,
        // ];
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  display: flex;
  flex-direction: column;
}
.form-group {
  display: inline-grid;
  margin-bottom: 20px;
}
.project-list {
  display: flex;
  flex-direction: column;
  height: 300px;
  overflow-y: scroll;
}
.project-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-right: 10px;
}
.errspan {
  float: right;
  margin-right: 6px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
}
.data-stage-parent {
  &:hover {
    .data-stage {
      background-color: #e0f0fd !important;
      border: 1px solid #00a3e9 !important;
    }
    .fa {
      color: #00a3e9 !important;
    }
    .errspan {
      color: #00a3e9 !important;
    }
  }
}
</style>
